<template>
  <footer id="glh-footer">
    <section class="footer-box">
      <ul>
        <li v-for="(item, idx) in navs" :key="idx">
          <h3>{{ $t(item.title) }}</h3>
          <a
            v-for="link in item.links"
            :key="link.url"
            :href="link.url"
            target="_blank"
            rel="nofollow"
          >
            {{ $t(link.text)
            }}
          </a>
        </li>
      </ul>
      <div class="parteners" v-if="showPartener">
        <h4>{{ $t('glh-footer.partener.title') }}</h4>
        <a
          target="_blank"
          v-for="item in partener"
          :href="item.url"
          :key="item.name"
          class="partener"
          rel="nofollow"
        >
          {{
          $t(item.name) }}
        </a>
      </div>
      <h4>{{ $t('glh-footer.statement.title') }}</h4>
      <p class="statement">{{ $t('glh-footer.statement.main') }}</p>
      <p class="sm">
        {{ $t('glh-footer.statement.aside') }}
        <span>
          <img src="https://cdn.gelonghui.com/static/web/gongan-icon.png" alt="gongan-icon" />
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502004122"
          >粤公网安备 44030502004122号</a>
        </span>
      </p>
      <div class="QrCode">
        <img src="https://cdn.gelonghui.com/static/web/erweima.png" alt />
        <p>{{$t('glh-footer.QrCode.uploadGLH')}}</p>
      </div>
    </section>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      showPartener: false,
      partener: [
        {
          name: 'glh-footer.partener.stcn',
          url: 'http://www.stcn.com/'
        },
        {
          name: 'glh-footer.partener.qq',
          url: 'https://new.qq.com/ch2/ganggu/'
        },
        {
          name: 'glh-footer.partener.sina',
          url: 'http://finance.sina.com.cn/stock/hkstock/'
        },
        {
          name: 'glh-footer.partener.163',
          url: 'http://money.163.com/hkstock/'
        },
        {
          name: 'glh-footer.partener.hexun',
          url: 'http://hk.stock.hexun.com/'
        },
        {
          name: 'glh-footer.partener.jrj',
          url: 'http://hk.jrj.com.cn/'
        },
        {
          name: 'glh-footer.partener.10jqka',
          url: 'http://www.10jqka.com.cn/'
        },
        {
          name: 'glh-footer.partener.eastmoney',
          url: 'http://www.eastmoney.com/'
        },
        {
          name: 'glh-footer.partener.xueqiu',
          url: 'https://xueqiu.com/'
        },
        {
          name: 'glh-footer.partener.stockstar',
          url: 'https://www.stockstar.com/'
        },
        {
          name: 'glh-footer.partener.cnfol',
          url: 'http://www.cnfol.com'
        },
        {
          name: 'glh-footer.partener.fx168',
          url: 'https://www.fx168.com/'
        },
        {
          name: 'glh-footer.partener.chinaventure',
          url: 'https://www.chinaventure.com.cn/'
        },
        {
          name: 'glh-footer.partener.moer',
          url: 'https://www.moer.cn/'
        },
        {
          name: 'glh-footer.partener.gildata',
          url: 'http://www.gildata.com/'
        },
        {
          name: 'glh-footer.partener.zqrb',
          url: 'http://www.zqrb.cn/'
        },
        {
          name: 'glh-footer.partener.cls',
          url: 'https://www.cls.cn/'
        },
        {
          name: 'glh-footer.partener.yzcj',
          url: 'http://www.123.com.cn/'
        },
        {
          name: 'glh-footer.partener.zbb',
          url: 'http://www.chinaipo.com/'
        }
      ],
      navs: [
        {
          title: 'glh-footer.navs.title.info',
          links: [
            {
              text: 'glh-footer.navs.links.about',
              url: '/introduction'
            },
            {
              text: 'glh-footer.navs.links.no-responsibility',
              url: '/relief'
            }
          ]
        },
        {
          title: 'glh-footer.navs.title.contact',
          links: [
            {
              text: 'glh-footer.navs.links.business',
              url: '/contactUs'
            },
            {
              text: 'glh-footer.navs.links.customerService',
              url: '/customerService'
            }
          ]
        },
        {
          title: 'glh-footer.navs.title.follow',
          links: [
            {
              text: 'glh-footer.navs.links.weibo',
              url: 'https://weibo.com/HKgelonghui?source=blog&is_hot=1'
            }
          ]
        },
        {
          title: 'glh-footer.navs.title.join',
          links: [
            {
              text: 'glh-footer.navs.links.hr',
              url: '/recruit'
            }
          ]
        }
      ]
    };
  },
  created() {
    if (this.$route.name === 'index') {
      this.showPartener = true;
    } else {
      this.showPartener = false;
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'index') {
        this.showPartener = true;
      } else {
        this.showPartener = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
#glh-footer {
  background-color: #1f2327;
  color: #fff;
  padding: 60px 20px;
  padding-bottom: 30px;
  z-index: 99;

  .footer-box {
    position: relative;
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;

    a {
      color: #fff;
    }

    ul {
      display: flex;
      justify-content: space-between;
      position: relative;
      padding: 40px 350px 0 0;

      li {
        h3 {
          font-size: 18px;
          // font-family: MicrosoftYaHei-Bold;
          font-weight: bold;
        }

        a {
          display: block;
          margin: 10px 0;
          font-size: 16px;
          color: #999;
          &:hover {
            color: #fff;
          }
        }
      }

      .download-logo {
        position: absolute;
        top: -20px;
        right: 0;
      }
    }

    .parteners {
      margin-bottom: 30px;
      width: 69%;
      a {
        color: #999;
      }
    }

    h4 {
      font-size: 18px;
      // font-family: MicrosoftYaHei-Bold;
      font-weight: bold;
      margin: 20px 0;
      margin-top: 40px;
    }

    .partener {
      padding-right: 10px;
      border-right: 1px solid #999;
      color: #fff;
      margin: 0 20px 20px 0;
      display: inline-block;

      // &:last-of-type {
      //   border-right: none;
      // }

      &:hover {
        color: #fff;
      }
    }

    .partener:nth-child(9),
    .partener:nth-child(17),
    .partener:nth-child(20) {
      border-right: none;
    }
    .statement {
      color: #999;
    }
    .QrCode {
      position: absolute;
      top: 42px;
      right: 150px;
      text-align: center;

      p {
        margin-top: 14px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(232, 232, 232, 1);
      }

      img {
        width: 150px;
      }
    }

    p {
      font-size: 14px;
      margin-bottom: 80px;
    }

    .sm {
      margin-bottom: 10px;
      img {
        height: 16px;
        width: 16px;
        vertical-align: bottom;
      }
    }
  }
}
</style>
